import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAppointment } from './programari.interface';

@Injectable({
    providedIn: 'root'
})
export class ProgramariService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private listDTProgramariURL =
        this.basePath +
        environment.interop.deps.programari.listDT;

    public printListProgramariURL =
        this.basePath +
        environment.interop.deps.programari.printList;

    public listScheduleProgramariURL =
        this.basePath +
        environment.interop.deps.programari.schedule;

    constructor(private http: HttpClient) { }

    listDTProgramari() {
        return this.http.post(this.listDTProgramariURL, {});
    }

    listSchedule(payload: { id_locatie_modul: number, date_from: string, date_to: string, id_tip_program: number | null }) { // id locatie activa
        return this.http.post<{ errors: boolean; data: IAppointment[]; status_code: number }>(
            this.listScheduleProgramariURL, payload
        );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
